import defaults from '../data/serviceDefaults.json';
import { getDefaultServiceOrderForm } from '../data/serviceOrderFormDefaults';

const clone = (value) => JSON.parse(JSON.stringify(value));
const CURRENT_SERVICE_CONTENT_VERSION = 15;

export const serviceDefaults = defaults;

export const createEmptyService = (sortOrder = 1, slug = '') => ({
  slug: '',
  title: '',
  subtitle: '',
  cardDescription: '',
  description: '',
  descriptionSecondParagraph: '',
  icon: 'FaBriefcase',
  image: '',
  featuresTitle: 'ویژگی‌های کلیدی',
  features: [],
  detailsTitle: 'توضیحات کامل',
  details: '',
  accordionItems: [],
  pricingTitle: 'پلن‌های خدمات',
  planGroups: [],
  pricingNoteTitle: 'توجه داشته باشید هر کدام از پلن‌ها قابل شخصی‌سازی هستند',
  pricingNoteText: '',
  orderForm: getDefaultServiceOrderForm(slug),
  portfolioTitle: 'نمونه کارها',
  portfolioGallery: [],
  works: [],
  seoLandingsTitle: 'راهکارهای تخصصی طراحی سایت',
  seoLandingsDescription: '',
  seoLandings: [],
  seoTitle: '',
  seoDescription: '',
  sortOrder,
  isActive: true,
  showOnHome: true,
  contentVersion: CURRENT_SERVICE_CONTENT_VERSION,
});

const matchingDefault = (service) => defaults.find((item) => (
  (service?.legacyId && Number(item.legacyId) === Number(service.legacyId))
  || (service?.slug && item.slug === service.slug)
  || (service?.title && item.title === service.title)
));

const hydratePlanGroups = (groups = [], fallbackGroups = []) => (
  clone(groups).map((group) => {
    const fallbackGroup = fallbackGroups.find((item) => String(item.id) === String(group.id));
    const mode = group.mode === 'request' || fallbackGroup?.mode === 'request'
      ? 'request'
      : 'plans';
    return {
      ...group,
      mode,
      request: {
        ...(fallbackGroup?.request || {}),
        ...(group.request || {}),
        highlights: Array.isArray(group.request?.highlights)
          ? group.request.highlights
          : clone(fallbackGroup?.request?.highlights || []),
      },
      durationOptions: mode === 'plans' && Array.isArray(group.durationOptions) && group.durationOptions.length
        ? group.durationOptions
        : mode === 'plans'
          ? clone(fallbackGroup?.durationOptions || [])
          : [],
      plans: mode === 'plans' && Array.isArray(group.plans) ? group.plans : [],
    };
  })
);

export const hydrateService = (service = {}) => {
  const fallback = matchingDefault(service);
  const isLegacy = Number(service.contentVersion || 0) < 1;
  const source = isLegacy && fallback ? { ...clone(fallback), ...service } : service;
  const base = createEmptyService(Number(source.sortOrder) || 1, source.slug);

  return {
    ...base,
    ...source,
    features: Array.isArray(source.features) && (!isLegacy || source.features.length)
      ? source.features
      : clone(fallback?.features || []),
    accordionItems: Array.isArray(source.accordionItems) && (!isLegacy || source.accordionItems.length)
      ? source.accordionItems
      : clone(fallback?.accordionItems || []),
    planGroups: Array.isArray(source.planGroups) && (!isLegacy || source.planGroups.length)
      ? hydratePlanGroups(source.planGroups, fallback?.planGroups || [])
      : clone(fallback?.planGroups || []),
    orderForm: source.orderForm?.fields?.length || source.orderForm?.introText
      ? { ...getDefaultServiceOrderForm(source.slug), ...clone(source.orderForm) }
      : getDefaultServiceOrderForm(source.slug),
    portfolioGallery: Array.isArray(source.portfolioGallery) && (!isLegacy || source.portfolioGallery.length)
      ? source.portfolioGallery
      : clone(fallback?.portfolioGallery || []),
    works: Array.isArray(source.works) && (!isLegacy || source.works.length)
      ? source.works
      : clone(fallback?.works || []),
    seoLandings: Array.isArray(source.seoLandings) && (!isLegacy || source.seoLandings.length)
      ? source.seoLandings
      : clone(fallback?.seoLandings || []),
    id: service._id || service.id || source.slug || source.legacyId,
  };
};

export const hydrateServices = (services, { fallbackToDefaults = false } = {}) => {
  const list = Array.isArray(services) && services.length
    ? services
    : fallbackToDefaults
      ? clone(defaults)
      : [];
  return list.map(hydrateService).sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
};

export const getServiceRouteKey = (service) => String(service?.legacyId || service?.slug || service?._id || service?.id || '');

export const serializeService = (service) => {
  const data = clone(service);
  ['_id', 'id', '__v', 'createdAt', 'updatedAt'].forEach((key) => delete data[key]);
  return { ...data, contentVersion: CURRENT_SERVICE_CONTENT_VERSION };
};

export const resolveServiceMediaUrl = (value) => {
  if (!value || !value.startsWith('/uploads/')) return value || '';
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  return `${apiUrl}${value}`;
};
